export default "__VITE_ASSET__CCrnYbs2__"